import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Mail, Phone, MapPin } from 'lucide-react';

const Footer17 = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const handleSubscribe = (e) => {
        e.preventDefault();
        if (email.trim()) {
            setEmail('');
        }
    };

    const galleryLinks = [
        { label: 'Curated Sarees', path: '/template17/shop' },
        { label: 'Art Kurtas', path: '/template17/shop' },
        { label: 'Gallery Pieces', path: '/template17/shop' },
        { label: 'Designer Edits', path: '/template17/shop' },
    ];

    const customerLinks = [
        { label: 'Contact Us', path: '/template17/contact' },
        { label: 'Shipping & Exchange', path: '/template17/shipping-exchange' },
        { label: 'FAQs', path: '/template17/faqs' },
        { label: 'Track Order', path: '/template17/orders' },
    ];

    const legalLinks = [
        { label: 'Privacy Policy', path: '/template17/privacy-policy' },
        { label: 'Terms & Conditions', path: '/template17/terms-conditions' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Source+Serif+4:wght@400;600;700&family=Inter:wght@300;400;500&display=swap');
            `}</style>

            <footer style={{ backgroundColor: '#FFFFFF', borderTop: '1px solid #E4E4E7' }}>
                {/* Main Footer Content */}
                <div
                    style={{
                        maxWidth: '1400px',
                        margin: '0 auto',
                        padding: '64px 24px',
                    }}
                    className="kala-footer-main"
                >
                    <div className="kala-footer-grid">
                        {/* Column 1: Brand */}
                        <div>
                            <h3
                                style={{
                                    fontFamily: "'Source Serif 4', Georgia, serif",
                                    fontSize: '28px',
                                    fontWeight: 600,
                                    color: '#18181B',
                                    letterSpacing: '3px',
                                    margin: '0 0 16px 0',
                                    textTransform: 'uppercase',
                                }}
                            >
                                KALA
                            </h3>
                            <p
                                style={{
                                    fontFamily: "'Inter', sans-serif",
                                    fontSize: '14px',
                                    color: '#71717A',
                                    lineHeight: 1.7,
                                    margin: '0 0 24px 0',
                                    fontWeight: 300,
                                }}
                            >
                                The Gallery of Indian Fashion. Where every garment is a work of art.
                            </p>
                            <div style={{ display: 'flex', gap: '12px' }}>
                                {[Instagram, Facebook].map((Icon, i) => (
                                    <a
                                        key={i}
                                        href="#"
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            border: '1px solid #E4E4E7',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#18181B',
                                            transition: 'all 0.3s ease',
                                            textDecoration: 'none',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = '#18181B';
                                            e.currentTarget.style.backgroundColor = '#18181B';
                                            e.currentTarget.style.color = '#FFFFFF';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = '#E4E4E7';
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                            e.currentTarget.style.color = '#18181B';
                                        }}
                                    >
                                        <Icon size={18} />
                                    </a>
                                ))}
                            </div>
                        </div>

                        {/* Column 2: Gallery */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Source Serif 4', Georgia, serif",
                                    fontSize: '15px',
                                    fontWeight: 600,
                                    color: '#18181B',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                The Gallery
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {galleryLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Inter', sans-serif",
                                                fontSize: '14px',
                                                fontWeight: 300,
                                                color: '#71717A',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#18181B')}
                                            onMouseLeave={(e) => (e.target.style.color = '#71717A')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 3: Customer Care */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Source Serif 4', Georgia, serif",
                                    fontSize: '15px',
                                    fontWeight: 600,
                                    color: '#18181B',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Support
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {customerLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Inter', sans-serif",
                                                fontSize: '14px',
                                                fontWeight: 300,
                                                color: '#71717A',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#18181B')}
                                            onMouseLeave={(e) => (e.target.style.color = '#71717A')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                                {legalLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Inter', sans-serif",
                                                fontSize: '14px',
                                                fontWeight: 300,
                                                color: '#71717A',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#18181B')}
                                            onMouseLeave={(e) => (e.target.style.color = '#71717A')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 4: Get In Touch */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Source Serif 4', Georgia, serif",
                                    fontSize: '15px',
                                    fontWeight: 600,
                                    color: '#18181B',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Get In Touch
                            </h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Mail size={16} style={{ color: '#71717A', flexShrink: 0 }} />
                                    <span style={{ fontFamily: "'Inter', sans-serif", fontSize: '14px', color: '#71717A', fontWeight: 300 }}>
                                        hello@kala.com
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Phone size={16} style={{ color: '#71717A', flexShrink: 0 }} />
                                    <span style={{ fontFamily: "'Inter', sans-serif", fontSize: '14px', color: '#71717A', fontWeight: 300 }}>
                                        +91 98765 43210
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                    <MapPin size={16} style={{ color: '#71717A', flexShrink: 0, marginTop: '2px' }} />
                                    <span style={{ fontFamily: "'Inter', sans-serif", fontSize: '14px', color: '#71717A', fontWeight: 300, lineHeight: 1.6 }}>
                                        Mumbai, Maharashtra, India
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div style={{ borderTop: '1px solid #E4E4E7' }}>
                    <div
                        style={{
                            maxWidth: '1400px',
                            margin: '0 auto',
                            padding: '20px 24px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                gap: '16px',
                            }}
                            className="kala-footer-bottom"
                        >
                            <p
                                style={{
                                    fontFamily: "'Inter', sans-serif",
                                    fontSize: '12px',
                                    color: '#A1A1AA',
                                    margin: 0,
                                    fontWeight: 300,
                                }}
                            >
                                &copy; 2026 KALA. All rights reserved.
                            </p>
                            <p
                                style={{
                                    fontFamily: "'Source Serif 4', Georgia, serif",
                                    fontSize: '12px',
                                    color: '#A1A1AA',
                                    margin: 0,
                                    fontStyle: 'italic',
                                }}
                            >
                                Art lives in every thread
                            </p>
                        </div>
                    </div>
                </div>

                {/* Responsive Styles */}
                <style>{`
                    .kala-footer-grid {
                        display: grid;
                        grid-template-columns: repeat(4, 1fr);
                        gap: 48px;
                    }
                    @media (max-width: 768px) {
                        .kala-footer-grid {
                            grid-template-columns: 1fr;
                            gap: 40px;
                        }
                        .kala-footer-main {
                            padding: 40px 24px !important;
                        }
                        .kala-footer-bottom {
                            flex-direction: column;
                            align-items: center !important;
                            text-align: center;
                        }
                    }
                    @media (min-width: 769px) and (max-width: 1024px) {
                        .kala-footer-grid {
                            grid-template-columns: repeat(2, 1fr);
                        }
                    }
                `}</style>
            </footer>
        </>
    );
};

export default Footer17;
